// <s-announcement-rotator> — shows one child of [data-rotator-track] at a time and cycles through them.
// Pauses on hover/focus. Under prefers-reduced-motion the swap happens without the slide transition (CSS).
// One component per file.
class SAnnouncementRotator extends HTMLElement {
  #ac = null;
  #timer = null;
  #index = 0;
  #paused = false;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    this.addEventListener("mouseenter", () => (this.#paused = true), { signal });
    this.addEventListener("mouseleave", () => (this.#paused = false), { signal });
    this.addEventListener("focusin", () => (this.#paused = true), { signal });
    this.addEventListener("focusout", () => (this.#paused = false), { signal });

    this.#index = 0;
    this.#show(0);
    this.dataset.ready = "true";

    const interval = parseInt(this.dataset.interval, 10) || 4000;
    if (this.#items().length > 1) {
      this.#timer = window.setInterval(() => {
        if (this.#paused || document.hidden) return;
        this.#show(this.#index + 1);
      }, interval);
    }
  }

  disconnectedCallback() {
    this.#ac?.abort();
    window.clearInterval(this.#timer);
  }

  #items() {
    const track = this.querySelector("[data-rotator-track]");
    return track ? [...track.children] : [];
  }

  #show(next) {
    const items = this.#items();
    if (!items.length) return;
    this.#index = next % items.length;
    items.forEach((item, i) => {
      const active = i === this.#index;
      item.toggleAttribute("data-active", active);
      item.setAttribute("aria-hidden", active ? "false" : "true");
    });
  }
}

if (!customElements.get("s-announcement-rotator")) {
  customElements.define("s-announcement-rotator", SAnnouncementRotator);
}
